const css = require('./orders-navigation.css');
const signals = require('../../../../signals/account/orders-list');
const { selectOrderType } = require('../../../../signals/account/orders');
let { cut } = require('../../../../helpers/utils');
const { Select, Radio } = require('account-ui');
const OrderStateCollapser = require('./order-state-collapser');
const OrderManagerCollapser = require('./order-manager-collapser');
const OrderTypeCollapser = require('./order-type-collapser');
const OrdersList = require('./orders-list');
const TextFilter = require('./text-filter');

class OrdersNavigation {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        return this.$context.getWatcherData().then((data) => Object.assign({}, data, { css }));
    }

    bind () {
        this.$context.signal(signals.onLoad);
        return {
            click: {
                [cut(css.clearFiltersButton)]: this.clearFilters
            }
        };
    }

    clearFilters () {
        this.$context.signal(signals.clearFilters);
    }
}

module.exports = {
    constructor: OrdersNavigation,
    children: [
        {
            name: 'select',
            component: Select,
            props: {
                signalOnSelect: signals.selectFilter,
                signalOnToggle: signals.togglePopup
            },
            watcher: {
                options: ['account', 'orders', 'computed', 'typeFilter', 'options'],
                isDisabled: ['account', 'orders', 'computed', 'typeFilter', 'isDisabled'],
                isOpen: ['account', 'popups', 'ordersFilter', 'isOpen']
            }
        },
        {
            name: 'order-state-collapser',
            component: OrderStateCollapser
        },
        {
            name: 'order-manager-collapser',
            component: OrderManagerCollapser
        },
        {
            name: 'order-type-collapser',
            component: OrderTypeCollapser
        },
        {
            name: 'text-filter',
            component: TextFilter
        },
        {
            name: 'orders-list',
            component: OrdersList,
            watcher: {
                ordersList: ['account', 'orders', 'computed', 'ordersList'],
                isManager: ['user', 'isManager']
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./components/account/orders/orders-navigation/index.js